<template>
	<AppDialog :dialogName="dialogName" min-width="500" :height="height">
		<div class="app-confirmation-dialog flex-centerize flex-column" :style="`height: ${height}px; max-width: ${contentMaxWidth}px;`">
			<h1 class="bold text-center mb-2">{{ title }}</h1>
			<h3 class="reg text-center mx-4">{{ description }}</h3>
			<div class="soft-note text-align-center soft-message font-size-sm" v-if="softNote">{{ softNote }}</div>
			<AppTextField class="mt-2" v-if="confirmationText" v-model="confirmationInput" :placeholder="confirmationPlaceholder" outlined />
			<div class="mt-12 display-flex flex-column">
				<CancelButton v-if="noText" class="mb-2" @click="no">{{ noText }}</CancelButton>

				<DangerButton v-if="isDanger" @click="yes" :disabled="blockYes">
					{{ yesText }}
				</DangerButton>
				<SecondaryButton v-else @click="yes" :disabled="blockYes">
					{{ yesText }}
				</SecondaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '../AppDialog/AppDialog';

import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from './app-confirmation-dialog.const';

export default {
	name: 'AppConfirmationDialog',
	components: {
		AppDialog,
	},
	props: {
		dialogName: { type: String }, //Todo: extract into a DialogMixin
		title: { type: String },
		description: { type: String },
		softNote: { type: String },
		yesText: { type: String },
		noText: { type: String },
		dialogPromiseHandlers: { type: Object },
		confirmationText: { type: String },
		isDanger: { type: Boolean, default: true },
		height: { type: [String, Number], default: '280' },
		contentMaxWidth: { type: Number, default: undefined },
	},
	methods: {
		yes() {
			if (this.blockYes) {
				return;
			}
			this.dialogPromiseHandlers.resolve(APP_CONFIRMATION_DIALOG_RESPONSES.YES);
			AppDialogManagerService.closeCurrentDialog();
		},
		no() {
			this.dialogPromiseHandlers.resolve(APP_CONFIRMATION_DIALOG_RESPONSES.NO);
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	computed: {
		blockYes() {
			return this.confirmationText && this.confirmationInput !== this.confirmationText;
		},
		confirmationPlaceholder() {
			return `Type "${this.confirmationText}" to confirm`;
		},
	},
	data() {
		return { confirmationInput: '' };
	},
};
</script>

<style scoped lang="scss">
.app-confirmation-dialog {
	margin: 0 auto;

	.soft-note {
		margin: 8px 0 -24px 0;
	}
}
</style>
